import blankReportWarningImg from '@/assets/images/blank-report-warning.webp';
import { Button } from '@/components/ui/button';

/**
 * What the step panel shows while the report does not exist yet.
 *
 * Every tool in this panel needs a report id, and a report only gets one once a
 * patient is chosen — so instead of each step explaining that in its own words,
 * they all defer to this one message and point at the single action that
 * unblocks them.
 */
export const UnsavedReportStepBlock = ({ onChoosePatient }: { onChoosePatient: () => void }) => (
    <div className="flex flex-col items-center gap-4 py-6 text-center">
        <img
            src={blankReportWarningImg}
            alt=""
            // Intrinsic size, so the panel reserves the box instead of
            // reflowing when the art lands.
            width={948}
            height={813}
            decoding="async"
            className="h-32 w-auto object-contain sm:h-40"
        />
        <div className="space-y-2">
            <h3 className="text-base font-semibold text-foreground">
                Escolha o paciente para criar o laudo
            </h3>
            <p className="text-sm leading-5 text-muted-foreground">
                Esta e as outras seções ficam disponíveis logo depois.
            </p>
        </div>
        <Button type="button" variant="outline" onClick={onChoosePatient}>
            Escolher paciente
        </Button>
    </div>
);
